import { jsx as _jsx } from "react/jsx-runtime";
export function Divider({ vertical, color = 'var(--border)', style, }) {
    return (_jsx("div", { style: vertical
            ? { width: 1, alignSelf: 'stretch', background: color, ...style }
            : { height: 1, background: color, width: '100%', ...style } }));
}
//# sourceMappingURL=Divider.js.map